export const openModal = (modal, data) => ({
    modal,
    data,
    type: 'OPEN_MODAL'
});

export const closeModal = (modal, data) => ({
    modal,
    data,
    type: 'CLOSE_MODAL'
});

export const toggleModal = (modal, data) => ({
    modal,
    data,
    type: 'TOGGLE_MODAL'
});

export const setModalData = (modal, data) => ({
    modal,
    data,
    type: 'SET_MODAL_DATA'
});


// WEBPACK FOOTER //
// ./src/actions/modal.js